import type { OAuthProvider } from 'src/app/auth/domain/models/oauth-provider'

import { buildOAuthUrl } from './build-oauth-url'

export const redirectToProvider = (provider: OAuthProvider): void => {
  const url = buildOAuthUrl({
    provider,
    clientOrigin: window.location.origin,
  })
  window.location.href = url
}
